export default "__VITE_ASSET__Clkml3ka__"